"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const DecisionIcon = props => /*#__PURE__*/_react.default.createElement(_base.Icon, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="m19.29 3.29-5 5A1 1 0 1 0 15.7 9.7l5-5a1 1 0 1 0-1.41-1.41M8.04 4.93a.96.96 0 1 0 .01-1.91L4.06 3A1.05 1.05 0 0 0 3 4.04l.02 4a.96.96 0 0 0 1.92-.01l-.02-3.11z"/><path d="M11 19.998A1 1 0 0 0 12 21c.552 0 1-.454 1-1.007v-7.4c0-.556-.315-1.322-.705-1.713L5.207 3.793 3.793 5.207 11 12.414z"/></g></svg>`
}, props));
DecisionIcon.displayName = 'DecisionIcon';
var _default = exports.default = DecisionIcon;